@if (oddsDisplayFormat$ | async; as oddsDisplayFormat) {
    <bs-digital-quick-bet-container class="quick-bet-module reward-tokens-module betslip-vars-scope" [oddsDisplayFormat]="oddsDisplayFormat" />
}
